var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-pagination-v2',{attrs:{"current-page":_vm.currentPage,"total-pages":_vm.totalPages,"total-items":_vm.meta.totalEntries,"page-size":_vm.meta.perPage,"is-r-t-l":_vm.isRTLView},on:{"page-change":_vm.onPageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }